/**
 * Module-scoped React Query client instance.
 * Created at module scope so it can be imported by auth utilities
 * that need to clear the cache on terminal auth failure.
 */
import { QueryClient } from "@tanstack/react-query";

/**
 * Shared React Query client instance.
 *
 * Created at module scope (not inside a React component) so that
 * auth-refresh.ts can call queryClient.clear() on terminal auth failure
 * without needing access to the React component tree.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: (failureCount, error) => {
				// Never retry UNAUTHORIZED -- the tRPC auth interceptor handles token refresh
				if (
					error instanceof Error &&
					"data" in error &&
					(error as { data?: { code?: string } }).data?.code === "UNAUTHORIZED"
				) {
					return false;
				}

				// For all other errors, retry once (original behavior)
				return failureCount < 1;
			},
		},
	},
});
